// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1SjwT","content":"LoadingAlert_content__3W3ZZ"};